import React, { useContext, useState } from 'react';
import { useSelector } from 'react-redux';
import { Header, Popup, Segment } from 'semantic-ui-react';
import { ButtonLink } from 'dyl-components';

import { CustomGroupUtils } from 'utils';

import AddInterestForm from 'shared/forms/AddInterestForm';
import { ArchivedRecordsContext } from 'shared/context/ArchivedRecordsProvider';

const InterestsSection = () => {
    const [isOpen , setIsOpen] = useState(false);

    const contact_interest_count = useSelector(state => {
        const custom_data = CustomGroupUtils.groupAndFlatten(state.contact.custom_data);
        return (custom_data.fields.interests || []).filter(interest => typeof interest === 'number').length;
    });
    const { isArchivedView } = useContext(ArchivedRecordsContext);
    return (
        <Popup
            trigger={
                <Segment>
                    <div style={{ display: 'flex' }}>
                        <Header style={{ margin: 0, flex: 1 }} as='h4'>Interests</Header>
                        {isArchivedView ? <span>{`${contact_interest_count} interest${contact_interest_count !== 1 ? 's' : ''}`}</span> : <ButtonLink>{`${contact_interest_count} interest${contact_interest_count !== 1 ? 's' : ''}`}</ButtonLink>}
                    </div>
                </Segment>
            }
            on="click"
            content={<AddInterestForm setIsOpen={setIsOpen} />}
            position="bottom center"
            flowing
            basic
            disabled={isArchivedView}
            open={isOpen}
            onOpen={() => !isArchivedView && setIsOpen(true)}
            onClose={() => setIsOpen(false)}
        />
    );
};

export default InterestsSection;
